export default __webpack_public_path__ + "static/media/illustration-health-3-m@2x.7d7a8a5a.webp";